import { render } from "./stock-adjustment-modal.vue?vue&type=template&id=1c3bfbed"
import script from "./stock-adjustment-modal.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__